import type { UniversityRepository } from "@src/domain/universities/repository/university_repository";
import type { UniversityDTO } from "../dto/university.dto";

/**
 * Use Case: Get University by ID
 */
export class GetUniversityByIdUseCase {
    constructor(private readonly universityRepository: UniversityRepository) { }

    async execute(id: string): Promise<UniversityDTO | null> {
        const university = await this.universityRepository.findById(id);

        if (!university) {
            return null;
        }

        return {
            university_id: university.universityId,
            name: university.name,
            code: university.code,
            description: university.description,
            address: university.address,
            website: university.website,
            is_active: university.isActive,
            created_at: university.createdAt.toISOString(),
            updated_at: university.updatedAt.toISOString(),
        };
    }
}